/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DevelopmentalProvisionPlanAiResponseDto } from '../../models/developmental-provision-plan-ai-response-dto';
import { RequestDevelopmentalProvisionPlanAiDto } from '../../models/request-developmental-provision-plan-ai-dto';

export interface DocumentAiControllerDevelopmentalProvisionPlanAi$Params {
  ticketId: string;
  centerId: string;
  type: string;
      body: RequestDevelopmentalProvisionPlanAiDto
}

export function documentAiControllerDevelopmentalProvisionPlanAi(http: HttpClient, rootUrl: string, params: DocumentAiControllerDevelopmentalProvisionPlanAi$Params, context?: HttpContext): Observable<StrictHttpResponse<DevelopmentalProvisionPlanAiResponseDto>> {
  const rb = new RequestBuilder(rootUrl, documentAiControllerDevelopmentalProvisionPlanAi.PATH, 'post');
  if (params) {
    rb.path('ticketId', params.ticketId, {});
    rb.query('centerId', params.centerId, {});
    rb.query('type', params.type, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DevelopmentalProvisionPlanAiResponseDto>;
    })
  );
}

documentAiControllerDevelopmentalProvisionPlanAi.PATH = '/api/document-ai/developmental-provision-plan-ai/{ticketId}';
